import styled, { css } from 'styled-components';

import {
    PRIMARY_MUTED,
    POSITIVE_MUTED,
    SECONDARY_MUTED,
    NEGATIVE_MUTED,
    CONTENT_BASE,
    SURFACE_BASE,
    PRIMARY_DISABLED,
    POSITIVE_DISABLED,
    SECONDARY_DISABLED,
    NEGATIVE_DISABLED,
} from '@amzn/ring-common-style-library/lib/colors';

import {
    BODY_SMALL_LIGHT,
    BODY_SMALL_MEDIUM,
} from '@amzn/ring-common-style-library/lib/typography';

interface AlertStyledProps {
    color: 'primary' | 'positive' | 'secondary' | 'negative' | 'neutral';
    position: 'top' | 'topBody' | 'bottom' | 'bottomBody';
    banner: boolean;
}

const alertColors = {
    primary: css`
        background-color: ${PRIMARY_DISABLED};
        border: 1px solid ${PRIMARY_MUTED};
        color: ${CONTENT_BASE};
        
    `,
    positive: css`
        background-color: ${POSITIVE_DISABLED};
        border: 1px solid ${POSITIVE_MUTED};
        color: ${CONTENT_BASE};
    `,
    secondary: css`
        background-color: ${SECONDARY_DISABLED};
        border: 1px solid ${SECONDARY_MUTED};
        color: ${CONTENT_BASE};
    `,
    negative: css`
        background-color: ${NEGATIVE_DISABLED};
        border: 1px solid ${NEGATIVE_MUTED};
        color: ${CONTENT_BASE};
    `,
    neutral: css`
        background-color: ${SURFACE_BASE};
        color: ${CONTENT_BASE};
    `,
};

const alertPositions = {
    top: css`
        top: 0;
    `,
    topBody: css`
        top: 53px;
    `,
    bottom: css`
        bottom: 0;
    `,
    bottomBody: css`
        bottom: 0;
    `,
};

export const Alert = styled.div<AlertStyledProps>`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    text-align: left;
    margin: ${({ banner }) => (banner ? '20px -16px' : '20px auto')};
    padding: 10px 16px;
    position: fixed;
    width: ${({ banner }) => (banner ? '100%' : '90%')};
    border-radius: ${({ banner }) => (banner ? '0' : '8px')};
    ${({ position }) => alertPositions[position]};
    ${({ color }) => alertColors[color]};
    ${BODY_SMALL_MEDIUM};

`;

export const CloseButton = styled.div`
    position: absolute;
    top: 4px;
    right: 4px;
    width: 16px;
    height: 16px;
    cursor: pointer;
    background: none;
    border: none;
    color: inherit;

    &:hover {
        opacity: 0.7;
    }
`;

export const Description = styled.div`
    margin-top: 5px;
    ${BODY_SMALL_LIGHT};
    color: ${CONTENT_BASE};
`;

export default {
    Alert,
    CloseButton,
    Description,
};
